// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import SlpTileView from '@tcp/core/src/components/features/browse/PlpTile/views/SlpTile.view';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import CATEGORY_LISTING_PAGE_CONSTANTS from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.constants';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles, {
  PlpTileContianer,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/styles/PaginatedPage.style.js';

const renderAddToBagLabel = (isBopisFilterOn) => {
  const plpTileLabels = getLabelFromCopyOrFromTranslation('PLP.plpTiles', PLPLabels);

  const pickupInStore = renderLabel(
    plpTileLabels.lbl_plp_pickup_in_store,
    'lbl_plp_pickup_in_store'
  );
  const addToBag = renderLabel(plpTileLabels.lbl_add_to_bag, 'lbl_add_to_bag');
  if (isBopisFilterOn) {
    return pickupInStore || CATEGORY_LISTING_PAGE_CONSTANTS.PICK_UP_IN_STORE;
  }
  return addToBag || CATEGORY_LISTING_PAGE_CONSTANTS.ADD_TO_BAG;
};

const SearchTileGrid = (props) => {
  const {
    products,
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    wishList,
    isBrierleyPromoEnabled,
    isBopisFilterOn,
    promotionsData,
    serverTime,
    isBuyMorePromoEnabled,
    trackClickPromotion,
    trackWishListClick,
    isLoggedIn,
    isPlcc,
    isInternationalShipping,
    isNewSwatchUrlEnabled,
    addToBagEcom,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isMostFavoritedBadgeEnabled,
    setPLPSLPAddToCartCTA,
    isInfluencerBadgeEnabled,
    isTileRedesignAB,
    isInfluencerPicksEnabled,
    favAddRemoveLoadingState,
    isAlternateImageOnHoverEnabled,
    isShowPriceRangeEnabled,
    isUpdatedPromotionsDisplayEnabled,
    imageConfigWithoutDPR,
    className,
    asPathVal,
    topRatedAttributeSLP,
    bestSellerAttributeSLP,
    mostFavoritedAttributeSLP,
    isTopRatedBadgeEnabledSLP,
    isBestSellerBadgeEnabledSLP,
    acrossBrandApiCalled,
    resetSlpLoadingState,
    searchQuery,
    alternateBrandsShown,
    currency,
    saveProductDataForQV,
    saveProductDataForPdp,
    isDynamicColorSwatchesEnabled,
    isHoverToPreviewColorSwatchesEnabled,
    isInteractiveColorSwatchBandEnabled,
    isFourTileGridEnabled,
    isSwatchAsColorUrlEnabled,
    isHoverToRevealATBButtonEnabled,
    isFeatureBrandView,
    featureBrand,
    isFeatureBrandEnabled,
    isFinalSaleABEnabled,
    isRandomBgColorEnabled,
    isDynamicBadgeEnabled,
    isDynamicBadgeEnabledAbtest,
  } = props;
  const tileActions = {
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    addToBagEcom,
  };

  // Determine the class for the SLP grid
  let slpGridClass = 'slp-grid';

  if (isFourTileGridEnabled) {
    slpGridClass += ' four-grid';
  }

  const sharedProps = {
    tileActions,
    wishListData: wishList,
    isBrierleyPromoEnabled,
    submitButtonText: renderAddToBagLabel(isBopisFilterOn),
    promotionsData,
    serverTime,
    trackClickPromotion,
    isBuyMorePromoEnabled,
    trackWishListClick,
    isLoggedIn,
    isPlcc,
    isInternationalShipping,
    trackAnalyticsClick: trackClickPromotion,
    isNewSwatchUrlEnabled,
    isBopisFilterOn,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isInfluencerBadgeEnabled,
    isTileRedesignAB: isTileRedesignAB || 'variationA',
    imageConfigWithoutDPR,
    pathName: asPathVal,
    topRatedAttributeSLP,
    bestSellerAttributeSLP,
    mostFavoritedAttributeSLP,
    acrossBrandApiCalled,
    resetSlpLoadingState,
    searchQuery,
    alternateBrandsShown,
    currency,
    saveProductDataForQV,
    saveProductDataForPdp,
    isDynamicColorSwatchesEnabled,
    isHoverToPreviewColorSwatchesEnabled,
    isInteractiveColorSwatchBandEnabled,
    isHoverToRevealATBButtonEnabled,
    setPLPSLPAddToCartCTA,
    isMostFavoritedBadgeEnabled,
    isTopRatedBadgeEnabledSLP,
    isBestSellerBadgeEnabledSLP,
    isInfluencerPicksEnabled,
    favAddRemoveLoadingState,
    isShowPriceRangeEnabled,
    isAlternateImageOnHoverEnabled,
    isUpdatedPromotionsDisplayEnabled,
    isSwatchAsColorUrlEnabled,
    isFeatureBrandView,
    featureBrand,
    isFeatureBrandEnabled,
    isFinalSaleABEnabled,
    isRandomBgColorEnabled,
    isDynamicBadgeEnabled,
    isDynamicBadgeEnabledAbtest,
  };
  return (
    <div className={`${className} slp-grid-wrapper`}>
      <div className={`${slpGridClass}`}>
        {products?.map((product, i) => {
          if (!product) return null;

          return (
            <PlpTileContianer
              key={`slp-tile-${product?.prodpartno}-${i}`}
              isFourTileGridEnabled={isFourTileGridEnabled}
            >
              <SlpTileView
                {...sharedProps}
                slpTileData={product}
                position={i}
                preloadImage={i <= 2}
              />
            </PlpTileContianer>
          );
        })}
      </div>
    </div>
  );
};

SearchTileGrid.propTypes = {
  onQuickViewOpenClick: PropTypes.func,
  onAddItemToFavorites: PropTypes.func,
  onSetLastDeletedItemIdAction: PropTypes.func,
  wishList: PropTypes.shape({}),
  isBrierleyPromoEnabled: PropTypes.bool,
  saveProductDataForPdp: PropTypes.func,
  isBopisFilterOn: PropTypes.bool,
  asPathVal: PropTypes.string,
  isPlcc: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  isNewSwatchUrlEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  isMostFavoritedBadgeEnabled: PropTypes.bool,
  setPLPSLPAddToCartCTA: PropTypes.string,
  isTileRedesignAB: PropTypes.bool,
  isInfluencerPicksEnabled: PropTypes.bool,
  isAlternateImageOnHoverEnabled: PropTypes.bool,
  isShowPriceRangeEnabled: PropTypes.bool,
};
SearchTileGrid.defaultProps = {
  onQuickViewOpenClick: () => {},
  onAddItemToFavorites: () => {},
  onSetLastDeletedItemIdAction: () => {},
  wishList: {},
  isBrierleyPromoEnabled: false,
  saveProductDataForPdp: () => {},
  isBopisFilterOn: false,
  asPathVal: '',
  isPlcc: false,
  isNewSwatchUrlEnabled: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  isMostFavoritedBadgeEnabled: false,
  setPLPSLPAddToCartCTA: null,
  isTileRedesignAB: false,
  isInfluencerPicksEnabled: false,
  isAlternateImageOnHoverEnabled: false,
  isShowPriceRangeEnabled: false,
};

export { SearchTileGrid as SearchTileGridVanilla };
export default withStyles(SearchTileGrid, styles);
